module.exports = __webpack_public_path__ + "assets/img/img-15.aee6e6f0.png";